export default "__VITE_ASSET__BWdjFDcN__"